require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-what-does-civil-society-hope-to-see-in-the-afdbs-updated.json") })
        }
      }, "path---en-us-update-what-does-civil-society-hope-to-see-in-the-afdbs-updated");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-what-does-civil-society-hope-to-see-in-the-afdbs-updated!./.cache/json/en-us-update-what-does-civil-society-hope-to-see-in-the-afdbs-updated.json
// module id = 834
// module chunks = 231608221292675